"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowHeaderCell = exports.ColumnHeaderCell = exports.Cell = exports.Row = exports.Body = exports.Header = exports.Root = void 0;
var table_js_1 = require("./table.js");
Object.defineProperty(exports, "Root", { enumerable: true, get: function () { return table_js_1.TableRoot; } });
var table_js_2 = require("./table.js");
Object.defineProperty(exports, "Header", { enumerable: true, get: function () { return table_js_2.TableHeader; } });
var table_js_3 = require("./table.js");
Object.defineProperty(exports, "Body", { enumerable: true, get: function () { return table_js_3.TableBody; } });
var table_js_4 = require("./table.js");
Object.defineProperty(exports, "Row", { enumerable: true, get: function () { return table_js_4.TableRow; } });
var table_js_5 = require("./table.js");
Object.defineProperty(exports, "Cell", { enumerable: true, get: function () { return table_js_5.TableCell; } });
var table_js_6 = require("./table.js");
Object.defineProperty(exports, "ColumnHeaderCell", { enumerable: true, get: function () { return table_js_6.TableColumnHeaderCell; } });
var table_js_7 = require("./table.js");
Object.defineProperty(exports, "RowHeaderCell", { enumerable: true, get: function () { return table_js_7.TableRowHeaderCell; } });
//# sourceMappingURL=table.parts.js.map